import React, { useState } from 'react'
import { Grid, Box, Tooltip } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import FormLabel from '@material-ui/core/FormLabel'
import * as yup from 'yup'
import { Formik, Field } from 'formik'
import { useIntl, FormattedMessage } from 'react-intl'
import ValidationErrors from '../../../../validations/ValidationErrors'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import messages from '../../../../messages'
import Antisense from './Antisense'
import { BitubeProperties } from '../../enum'
import InfoIcon from '@material-ui/icons/Info'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import {
  useFastduplexRuleValidationMutation,
  useSessionFieldsMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'

import { biTubeConfigContext } from '../../BiTube'
import {
  getOverhangValue,
  getFiveModValue,
  getBaseValue,
  getThreeModValue,
} from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import OligoNameWarning from '../../../../validations/oligoNameWarning'
import {
  validateTextUpdated as validateText,
  convertToASCII,
} from '@src/routes/Configurators/utils/util'
import { ListError } from '../../Reducer'
import { ConfiguratorValues } from '../../../../utils/constants'
import styles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'

const sequenceKey = messages.CONF_SEQUENCE_TEXT.defaultMessage
const nameKey = messages.CONF_OLIGO_NAME_KEY.defaultMessage
export const CustomerOverHangKey = 'customeroverhang'
let baseValue = ''

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(5, 5),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      margin: theme.spacing(4, 0),
    },
    baseCount: {
      fontSize: theme.typography.pxToRem(14),
      margin: theme.spacing(0, 0, 2),
    },
    baseContent: {
      fontSize: theme.typography.pxToRem(12),
    },
    InfoIcon: {
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5),
    },
    arrow: {
      color: theme.palette.common.white,
    },
    InfoPopup: {
      maxWidth: theme.spacing(65),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      boxShadow: theme.shadows[4],
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.black,
      borderRadius: '2%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    switchLabel: {
      fontSize: theme.typography.pxToRem(12),
      color: '#1b1b25',
    },
    sequenceInput: {
      '&.Mui-error': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-error:hover': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '& input': {
        '&:-webkit-autofill': {
          transition: 'background-color 5000s ease-in-out 0s',
        },
      },
    },

    sequenceLabel: {
      '& label': {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.primary,
      margin: theme.spacing(0, 0, 2),
      display: 'inline-flex',
    },
    alignRight: {
      paddingLeft: theme.spacing(7),
    },
    switchRoot: {
      height: 44,
      width: 52,
      paddingLeft: 5,
    },
    switchTrack: {
      borderRadius: 10,
      backgroundColor: '#a1a1a1',
    },
    switchBase: {
      top: 8,
      left: 2,
      padding: 5,
      '&$checked': {
        color: '#fff',
        transform: 'translateX(14px)',
        '& + $switchTrack': {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 17,
      height: 17,
      color: 'white',
    },
    base: {
      paddingLeft: theme.spacing(38),
      paddingTop: theme.spacing(1),
    },
    mt20: {
      marginTop: theme.spacing(5),
    },
    starndPadd: {
      paddingLeft: theme.spacing(7),
      paddingTop: theme.spacing(1),
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.grey[500],
      // marginRight:theme.spacing(3)
    },
    alignTop: {
      marginTop: theme.spacing(-5),
      // paddingRight:theme.spacing(3)
    },
    alignTop2: {
      marginTop: theme.spacing(1),
      // paddingRight:theme.spacing(3)
    },
    checked: {},
    validateError: {
      marginLeft: theme.spacing(-4),
      marginTop: theme.spacing(-4),
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      paddingLeft: theme.spacing(4),
      paddingTop: theme.spacing(2),
    },
    overhangLabel: {
      paddingLeft: theme.spacing(4),
    },
    sequenceType: {
      color: '#9e9e9e',
      fontSize: theme.typography.pxToRem(12),
      display: 'flex',
      alignItems: 'flex-end',
    },
    warningBox: {
      padding: theme.spacing(3, 0, 0, 0),
    },
  }
})

export enum DefaultValue {
  Select = 'Select',
  ThreeModification = 'threeMod',
  FiveModiFication = 'fiveMod',
  OverHang = 'overhang',
  Category = '',
  Base = 'base',
  AddBases = 'Add Modified Bases',
}
export const selectOverhang = {
  label: DefaultValue.Select,
  value: DefaultValue.Select,
}
export const seqDataToUpperCase = (seq) => {
  let newSequence = ''
  for (let i = 0; i < seq.length; i++) {
    const ch = seq.charAt(i)
    if (ch !== '[') {
      let data = ''
      data = ch
      newSequence = newSequence + data.toUpperCase()
      newSequence = newSequence.replace('T', 'U')
    } else {
      newSequence = newSequence + '['
      i = i + 1
      for (let j = i; j < seq.length; j++) {
        const char = seq.charAt(j)
        newSequence = newSequence + char
        if (char === ']' || j === seq.length - 1) {
          i = j
          break
        }
      }
    }
  }
  return newSequence
}

let insertPos = 0
let setPosition = false
const FastSequenceInfo = (props) => {
  const { productDetails, specifications } = props
  const classes = useStyles()
  const GlobalCSS = styles()
  const seqInput: any = document.getElementById('sequence')
  const [nameValidationErrors, setNameValidationErrors] = useState<string[]>([])
  const intl = useIntl()
  let splChar = ''

  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const {
    sessionData,
    currentOligoIndex,
    productInformation,
    validateOnClick,
  } = bitubeState
  const { instructions } = productInformation
  const [senseName, setSenseName] = useState<string | null | undefined>('')
  const [senseSequence, setSenseSequence] = useState<string | null | undefined>(
    ''
  )

  const [overhang, setOverhang] = useState<string | null | undefined>('')

  const [sessionFields] = useSessionFieldsMutation()
  const [fastduplexRuleValidation] = useFastduplexRuleValidationMutation()
  const [sequenceValidation, setSequenceValidation] = useState<string[]>([])
  const [overhangValidation, setOverhangValidation] = useState<string[]>([])
  const [threeMod, setThreeMod] = useState<string | null | undefined>('')
  const [fiveMod, setFiveMod] = useState<string | null | undefined>('')
  const [sessionDataChanged, setSessionDataChanged] = useState<
    boolean | null | undefined
  >(false)
  const [isSequence, setIsSequence] = useState(false)
  const debouncedSequenceData = useDebounce(
    senseSequence,
    BitubeProperties.SEQUENCE_API_TIME
  )
  const [isSequencekeyUp, setIsSequencekeyUp] = useState<boolean>(false)
  const [baseCount, setBaseCount] = useState<number>(0)
  const [isSeqEmpty, setIsSeqEmpty] = useState<boolean>(false)
  const [baseSelected, setBaseSelected] = useState<boolean>(false)
  const oligoNameRegex =
    /^[a-zA-Z0-9_#*()., +.[\-\]/]*$|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g

  const sessionDataToSession = async (obj) => {
    if (bitubeState.isDeleteAll) {
      await sessionFields({
        variables: { input: [], productInput: productDetails },
      })
      biTubeDispatch({ type: 'IS_DELETE_ALL', data: false })
    } else {
      await sessionFields({
        variables: { input: obj, productInput: productDetails },
      })
    }
  }
  React.useEffect(() => {
    if (bitubeState.callSessionAPI) {
      sessionDataToSession(sessionData)
      biTubeDispatch({
        type: 'CALL_SESSION_API',
        data: false,
      })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.callSessionAPI])
  const handleRuleValidationError = (errorList) => {
    const error: any[] = []
    let hasAntiSeqErr = false
    let hasSameErr = false
    let hasOverhangErr = false
    errorList.forEach((item) => {
      delete item?.__typename
      if (item?.key === sequenceKey) {
        hasSameErr = false
        error.push(item)
        sessionData[currentOligoIndex].listError.forEach((err) => {
          //if the same error is there in sessiondata, do not push the error
          if (err.key === sequenceKey && err.value === item.value) {
            hasSameErr = true
          }
        })
        if (!hasSameErr)
          sessionData[currentOligoIndex].listError.push({
            key: item.key,
            value: item.value,
          })
      }
      if (item?.key === BitubeProperties.AntiSequenceKey) {
        hasAntiSeqErr = true
      }
      if (item?.key === CustomerOverHangKey) {
        hasOverhangErr = true
      }
    })
    if (!error.length) {
      // if the seq error is removed, remove it from the list array
      const seqError: ListError[] = []
      sessionData[currentOligoIndex].listError.forEach((err) => {
        if (err.key === sequenceKey) {
          seqError.push(err)
        }
      })
      const array = sessionData[currentOligoIndex].listError
      seqError.forEach((e) => {
        const index = array.indexOf(e)
        if (index !== -1) {
          array.splice(index, 1)
        }
      })
    }
    //if the antiseq error is removed after changing seq...remove the anti seq error from list error
    if (!hasAntiSeqErr) {
      const antiSeqError: ListError[] = []
      sessionData[currentOligoIndex].listError.forEach((err) => {
        if (err.key === BitubeProperties.AntiSequenceKey) {
          antiSeqError.push(err)
        }
      })
      const array = sessionData[currentOligoIndex].listError
      antiSeqError.forEach((e) => {
        const index = array.indexOf(e)
        if (index !== -1) {
          array.splice(index, 1)
        }
      })
    }
    //if the overhang error is removed after changing seq...remove the anti seq error from list error
    if (!hasOverhangErr) {
      const overHangError: ListError[] = []
      sessionData[currentOligoIndex].listError.forEach((err) => {
        if (err.key === CustomerOverHangKey) {
          overHangError.push(err)
        }
      })
      const array = sessionData[currentOligoIndex].listError
      overHangError.forEach((e) => {
        const index = array.indexOf(e)
        if (index !== -1) {
          array.splice(index, 1)
        }
      })
    }
  }
  const ruleValidation = async (obj) => {
    const response = await fastduplexRuleValidation({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.fastduplexRuleValidation.serverError) {
      if (data.fastduplexRuleValidation.listErrors) {
        handleRuleValidationError(data.fastduplexRuleValidation.listErrors)
      }
      biTubeDispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: data.fastduplexRuleValidation,
      })
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [...bitubeState.sessionData],
      })
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }

  const oligoNameMaxLength = Number(
    intl.formatMessage(messages.CONF_DUPLEX_NAME_MAX_LENGTH)
  )
  //function to extract the special characters from the string passed
  const getOligoNameSpecialCharacter = (val): string => {
    setSenseName(val)
    splChar = ''
    val.split('').forEach((c) => {
      if (!c.match(oligoNameRegex) && !splChar.includes(c)) {
        if (splChar === '') {
          splChar = c
        } else {
          splChar = splChar + ', ' + c
        }
      }
    })
    return splChar
  }
  const handleName = (val) => {
    const oligoNameSpecialCharacter = getOligoNameSpecialCharacter(val)
    sessionData[currentOligoIndex].name = val.trim()
    biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
    const validator = yup
      .string()
      .trim()
      .required(intl.formatMessage(messages.CONF_REQUIRED_FIELD))
      .max(
        oligoNameMaxLength,
        intl.formatMessage(messages.CONF_OLIGO_NAME_MAX_LENGTH_MASSAGE) +
          oligoNameMaxLength
      )
      .matches(
        /^[a-zA-Z0-9_#*().,:+.[\-\]/ ]*$/,
        oligoNameSpecialCharacter
          ? intl.formatMessage(
              messages.CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE
            ) + oligoNameSpecialCharacter
          : ' '
      )
    const errors: any[] = []
    try {
      setNameValidationErrors([])
      validator.validateSync(val, { abortEarly: false })
      let nameError: ListError = {}
      //if there is only one error and thats name error then clear the list error
      sessionData[currentOligoIndex].listError.forEach((err) => {
        if (err.key === nameKey) {
          nameError = err
        }
      })
      const array = sessionData[currentOligoIndex].listError
      const index = array.indexOf(nameError)
      if (index !== -1) {
        array.splice(index, 1)
      }
    } catch (error: any) {
      if (error.errors && error.errors[0] !== ' ') {
        for (const err of error.errors) {
          let hasSameErr = false
          sessionData[currentOligoIndex].listError.forEach((error) => {
            if (error.key === BitubeProperties.NameKey && error.value === err) {
              hasSameErr = true
            }
          })
          errors.push(err)
          if (!hasSameErr) {
            sessionData[currentOligoIndex].listError.push({
              key: 'name',
              value: err,
            })
          }
        }
        setNameValidationErrors(errors)
      } else {
        sessionData[currentOligoIndex].listError.length = 0
        setNameValidationErrors([])
      }
    }
    return null
  }
  const handleOnBlur = (event) => {
    const { name, value } = event.target
    if (name === BitubeProperties.NameKey) {
      sessionData[currentOligoIndex][name] = value.trim()
    } else {
      sessionData[currentOligoIndex][name] = value
    }
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
    if (name === BitubeProperties.NameKey) {
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...bitubeState.errorData, [name]: value.trim() },
      })
    } else {
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: { ...bitubeState.errorData, [name]: value },
      })
    }
    biTubeDispatch({
      type: 'SET_CONTINUE_TO_NEXT_PAGE',
      data: false,
    })
  }
  const checkValidation = (response) => {
    setSequenceValidation([])
    const overHangError: string[] = []
    const error: string[] = []
    if (sessionData[currentOligoIndex].isOverridden) setOverhangValidation([])
    if (bitubeState.seqLength !== 0 && response.listErrors) {
      response.listErrors.forEach((obj) => {
        if (
          obj.key === sequenceKey ||
          (obj.key === ConfiguratorValues.SequencePriority &&
            obj.value !== messages.CONF_REQUIRED_FIELD.defaultMessage)
        ) {
          error.push(obj.value)
        }
        if (
          obj.key === CustomerOverHangKey &&
          sessionData[currentOligoIndex].isOverridden
        ) {
          overHangError.push(obj.value)
        }
      })
      if (overHangError.length) {
        setOverhangValidation(overHangError)
      }
      if (error.length === 0) {
        biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: true })
      } else {
        biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
        setSequenceValidation(error)
      }
    }
  }
  const checkOverrideValidation = (response) => {
    setSequenceValidation([])
    setOverhangValidation([])
    const nameError: string[] = []
    const sequenceError: string[] = []
    const overHangError: string[] = []
    if (response.listErrors) {
      response.listErrors.forEach((obj) => {
        if (obj.key === sequenceKey) {
          sequenceError.push(obj.value)
        }
        if (obj.key === CustomerOverHangKey) {
          overHangError.push(obj.value)
        }
      })
    }
    if (sequenceError.length === 0) {
      biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: true })
    } else {
      biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
      setSequenceValidation(sequenceError)
    }
    if (overHangError.length) {
      setOverhangValidation(overHangError)
    }
    if (response.listErrors) {
      response.listErrors.forEach((obj) => {
        if (obj.key === nameKey) {
          nameError.push(obj.value)
        }
      })
    }
    setNameValidationErrors(nameError)
  }

  const checkTotalValidation = (listErrors) => {
    setSequenceValidation([])
    setOverhangValidation([])
    const seqError: string[] = []
    const nameError: string[] = []
    const overhangError: string[] = []
    let priorityErr = false
    let seqIsRequiredErr = false
    if (listErrors) {
      listErrors.forEach((obj) => {
        if (
          obj.key === sequenceKey ||
          obj.key === ConfiguratorValues.SequencePriority
        ) {
          seqError.push(obj.value)

          if (obj.value === BitubeProperties.RequiredField) {
            seqIsRequiredErr = true
          }
        }
        if (obj.key === ConfiguratorValues.SequencePriority) priorityErr = true
        if (obj.key === nameKey) {
          nameError.push(obj.value)
        }
        if (obj.key === CustomerOverHangKey) {
          overhangError.push(obj.value)
        }
      })
      if (!seqError.length) {
        biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: true })
      } else {
        biTubeDispatch({ type: 'UPDATE_VALID_SEQUENCE', data: false })
      }
      if (sessionData[currentOligoIndex].isOverridden && !priorityErr) {
        if (seqIsRequiredErr) {
          setSequenceValidation([
            intl.formatMessage(messages.CONF_REQUIRED_FIELD),
          ])
        } else {
          setSequenceValidation([])
        }
        setOverhangValidation([])
      } else {
        setSequenceValidation(seqError)
        setOverhangValidation(overhangError)
      }
      setNameValidationErrors(nameError)
    }
  }
  const handleDropDownSelect = (event) => {
    const { name, value } = event.target
    if (name === BitubeProperties.CustomerOverHang) {
      if (value !== DefaultValue.Select) {
        setOverhangValidation([])
        setOverhang(value)
      } else {
        if (!sessionData[currentOligoIndex].isOverridden) {
          setOverhangValidation([
            intl.formatMessage(messages.CONF_REQUIRED_FIELD),
          ])
          let hasSameErr = false
          sessionData[currentOligoIndex].listError.forEach((err) => {
            //if the same error is there in sessiondata, do not push the error
            if (err.key === CustomerOverHangKey) {
              hasSameErr = true
            }
          })
          if (!hasSameErr)
            sessionData[currentOligoIndex].listError.push({
              key: CustomerOverHangKey,
              value: intl.formatMessage(messages.CONF_REQUIRED_FIELD),
            })
        }
        setOverhang('')
      }
    }
    if (name === BitubeProperties.ThreeMod) {
      setThreeMod(value)
    }
    if (name === BitubeProperties.FiveMod) {
      setFiveMod(value)
    }
    if (
      name === BitubeProperties.CustomerOverHang &&
      value === DefaultValue.Select
    ) {
      sessionData[currentOligoIndex][name] = ''
    } else {
      sessionData[currentOligoIndex][name] = value
    }
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...bitubeState.errorData,
        [name]: value === DefaultValue.Select ? '' : value,
      },
    })
    biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
    setSessionDataChanged(true)
  }
  const countBases = (data) => {
    data = data.replace(/ *\[[^\]]*]/g, 'A')
    const baseSequence = data
    let count = 0
    for (const seqChar of baseSequence) {
      if (
        seqChar === '*' ||
        seqChar === '+' ||
        seqChar === '\u0020' ||
        seqChar === '\u000A'
      ) {
      } else {
        count += 1
      }
    }

    setBaseCount(count)
  }
  const handleClick = () => {
    setPosition = true
  }
  const insertAtCaret = (baseValue) => {
    const base: any = document.getElementById('sequence')
    let inputValue = base.value

    if (base !== null) {
      let caretPos: any = base.selectionStart
      let selEnd = base.selectionEnd
      if (base.selectionStart === 0) {
        // if the cursor is not placed manually
        if (!setPosition) {
          if (insertPos === 0) {
            // if the base needs to be appended at the end
            caretPos = inputValue.length
            selEnd = inputValue.length
            insertPos = caretPos
          } else {
            //if the base needs to be added after the last inserted base
            caretPos = insertPos
            selEnd = caretPos
            insertPos = insertPos + baseValue.length
          }
        } else {
          //if the cursor is placed in the first position manually
          insertPos = base.selectionStart + baseValue.length
          setPosition = false
        }
      } else {
        // if the cursor is placed to a position, update insertPos
        insertPos = base.selectionStart + baseValue.length
        setPosition = false
      }
      const front = inputValue.substring(0, caretPos)
      const back = inputValue.substring(selEnd, inputValue.length)
      inputValue = front + baseValue + back
    }

    return inputValue
  }

  const handleDropDownSelectBase = (event) => {
    const { name, value } = event.target
    if (name === 'base') baseValue = value
    const sequence = insertAtCaret(baseValue)
    countBases(sequence)
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...bitubeState.errorData,
        sequence: sequence,
      },
    })
    sessionData[currentOligoIndex].sequence = sequence
    setSenseSequence(sequence)
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
    biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
    setSessionDataChanged(true)
    setBaseSelected(true)
  }

  const callSeqValidationAPI = () => {
    setSessionDataChanged(true)
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...bitubeState.errorData, sequence: senseSequence },
    })
    sessionData[currentOligoIndex].sequence = senseSequence
    biTubeDispatch({
      type: 'UPDATE_INPUT',
      data: [...bitubeState.sessionData],
    })
    biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
    biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
    biTubeDispatch({
      type: 'SET_CONTINUE_TO_NEXT_PAGE',
      data: false,
    })
    //STRAT-17045
    biTubeDispatch({
      type: 'UPDATE_SEQUENCE_LENGTH',
      data: baseCount,
    })
    //STRAT-17045
  }

  React.useEffect(() => {
    if (seqInput && sessionData[currentOligoIndex].sequence?.length) {
      if (baseSelected) {
        seqInput.focus()
        setBaseSelected(false)
      }

      seqInput.selectionEnd = insertPos
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [senseSequence])

  const countText = (value) => {
    insertPos = seqInput.selectionStart
    const val = seqDataToUpperCase(
      value.replace(/[\u007F-\u00A0]/g, '').replace(/\\f/g, '')
    )
    countBases(val)
    setSenseSequence(val)
  }
  React.useEffect(() => {
    //if the sense sequence is blank and the autogenerate antisense is checked, display required error for the sequence field
    if (
      sessionData[currentOligoIndex].autoGenerateOligo &&
      (!productDetails.isCSRSupervisor ||
        !sessionData[currentOligoIndex].isOverridden)
    ) {
      if (sessionData[currentOligoIndex].sequence === '') {
        setSequenceValidation([
          intl.formatMessage(messages.CONF_REQUIRED_FIELD),
        ])
        let hasSameErr = false
        sessionData[currentOligoIndex].listError.forEach((err) => {
          //if the same error is there in sessiondata, do not push the error
          if (
            err.key === sequenceKey &&
            err.value === intl.formatMessage(messages.CONF_REQUIRED_FIELD)
          ) {
            hasSameErr = true
          }
        })
        if (!hasSameErr)
          sessionData[currentOligoIndex].listError.push({
            key: sequenceKey,
            value: intl.formatMessage(messages.CONF_REQUIRED_FIELD),
          })
      }
      //for overhang
      if (sessionData[currentOligoIndex].customerOverhang === '') {
        setOverhangValidation([
          intl.formatMessage(messages.CONF_REQUIRED_FIELD),
        ])
        let hasSameErr = false
        sessionData[currentOligoIndex].listError.forEach((err) => {
          //if the same error is there in sessiondata, do not push the error
          if (err.key === CustomerOverHangKey) {
            hasSameErr = true
          }
        })
        if (!hasSameErr)
          sessionData[currentOligoIndex].listError.push({
            key: CustomerOverHangKey,
            value: intl.formatMessage(messages.CONF_REQUIRED_FIELD),
          })
      }
    }
  }, [sessionData[currentOligoIndex].autoGenerateOligo])

  React.useEffect(() => {
    if (bitubeState.addNewDuplex || bitubeState.deleteLastOligo) {
      setIsSeqEmpty(false)
    }
    if (bitubeState.deleteLastOligo) {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      biTubeDispatch({
        type: 'UPDATE_VALID_SEQUENCE',
        data: true,
      })
      setSequenceValidation([])
      setNameValidationErrors([])
      setOverhangValidation([])
      window.scrollTo(0, 0)
    }
  }, [
    bitubeState.oligoCount,
    bitubeState.deleteLastOligo,
    bitubeState.addNewDuplex,
  ])

  React.useEffect(() => {
    if (bitubeState.deleteSelected === 1) {
      checkTotalValidation(sessionData[currentOligoIndex].listError)
      biTubeDispatch({
        type: 'IS_DELETE_SELECTED',
        data: 2,
      })
    }
  }, [bitubeState.deleteSelected])
  React.useEffect(() => {
    if (
      sessionData[currentOligoIndex].sequence?.length !== 0 ||
      sessionData[currentOligoIndex].name?.length !== 0 ||
      bitubeState.sessionData[bitubeState.currentOligoIndex].isOverridden !==
        null
    ) {
      if (
        productDetails.isCSRSupervisor &&
        !bitubeState.sessionData[bitubeState.currentOligoIndex].isOverridden &&
        bitubeState.overiddenNumber !== 0
      ) {
        checkOverrideValidation(bitubeState.errorResponseJson)
      } else {
        checkValidation(bitubeState.errorResponseJson)
      }

      const error: any[] = []
      if (bitubeState.errorResponseJson.listErrors) {
        bitubeState.errorResponseJson.listErrors.forEach((item) => {
          delete item.__typename
          if (
            item.key === sequenceKey ||
            item.key === nameKey ||
            item.key === CustomerOverHangKey
          ) {
            error.push(item)
          }
        })

        if (error.length > 0) {
          biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
          biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
        }
      }
    }
    if (bitubeState.errorResponseJson.baseCount)
      sessionData[currentOligoIndex].baseCount = Number(
        bitubeState.errorResponseJson.baseCount
      )

    if (bitubeState.errorResponseJson.antisenseBaseCount)
      sessionData[currentOligoIndex].antisenceBaseCount = Number(
        bitubeState.errorResponseJson.antisenseBaseCount
      )

    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.errorResponseJson])
  React.useEffect(() => {
    if (bitubeState.overriddenFlag && bitubeState.overiddenNumber !== 0) {
      const listErrors = bitubeState.errorResponseJson.listErrors

      checkTotalValidation(listErrors)
      //biTubeDispatch({ type: 'HAS_OVERRIDDEN_FLAG', data: false })
    }

    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.overriddenFlag])
  React.useEffect(() => {
    setSessionDataChanged(true)
  }, [])

  React.useEffect(() => {
    if (
      productDetails.isCSRSupervisor &&
      bitubeState.overiddenNumber === 0 &&
      bitubeState.deleteLastOligo === 1
    ) {
      checkTotalValidation(sessionData[currentOligoIndex].listError)
    }

    countBases(sessionData[currentOligoIndex].sequence)
    //STRAT-17045
    biTubeDispatch({
      type: 'UPDATE_SEQUENCE_LENGTH',
      data: sessionData[currentOligoIndex].sequence?.length,
    })
    //STRAT-17045
    let overhandVal = sessionData[currentOligoIndex].customerOverhang
    if (
      overhandVal === '' ||
      overhandVal === null ||
      overhandVal === undefined
    ) {
      overhandVal = DefaultValue.Select
      sessionData[currentOligoIndex].customerOverhang = ''
    }

    let threeModVal = sessionData[currentOligoIndex].threeMod

    if (
      threeModVal === '' ||
      threeModVal === null ||
      threeModVal === undefined
    ) {
      threeModVal = BitubeProperties.None
      sessionData[currentOligoIndex].threeMod = BitubeProperties.None
    }
    let fiveModVal = sessionData[currentOligoIndex].fiveMod

    if (fiveModVal === '' || fiveModVal === null || fiveModVal === undefined) {
      fiveModVal = BitubeProperties.None
      sessionData[currentOligoIndex].fiveMod = BitubeProperties.None
    }
    setSenseSequence(sessionData[currentOligoIndex].sequence)
    setOverhang(overhandVal)
    setThreeMod(threeModVal)
    setFiveMod(fiveModVal)
    if (
      sessionData[currentOligoIndex].name?.length ||
      sessionData[currentOligoIndex].sequence?.length ||
      sessionData[currentOligoIndex].antisenceName?.length ||
      sessionData[currentOligoIndex].antisenceSequence?.length
    ) {
      biTubeDispatch({
        type: 'DELETE_LAST_OLIGO',
        data: 0,
      })
      sessionDataToSession(sessionData)
    }
    biTubeDispatch({
      type: 'UPDATE_ERROR_DATA',
      data: {
        ...bitubeState.errorData,
        threeMod: threeModVal,
        customerOverhang:
          overhandVal === DefaultValue.Select ? '' : overhandVal,
        fiveMod: fiveModVal,
        sequence: sessionData[currentOligoIndex].sequence,
        name: sessionData[currentOligoIndex].name,
      },
    })
    //if the session items  doesnt have any list error, clear the header error
    let hasError = false
    sessionData.forEach((item) => {
      if (item.listError && item.listError.length !== 0) {
        hasError = true
      }
    })

    if (!hasError) {
      biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData, bitubeState.currentOligoIndex])

  React.useEffect(() => {
    setIsSeqEmpty(false)
    setSenseName(sessionData[currentOligoIndex].name)
    checkTotalValidation(sessionData[currentOligoIndex].listError)
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.currentOligoIndex])

  React.useEffect(() => {
    if (bitubeState.seqLength !== 0 && sessionDataChanged) {
      ruleValidation(bitubeState.errorData)
      setSessionDataChanged(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.errorData])

  React.useEffect(() => {
    if (bitubeState.senseValidation) {
      handleRuleValidationError(bitubeState.errorResponseJson.listErrors)
      biTubeDispatch({ type: 'SENSE_VALIDATION', data: false })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.senseValidation])
  React.useEffect(() => {
    if (
      !bitubeState.isValidTotalValidation &&
      bitubeState.totalValidation[bitubeState.currentOligoIndex]
    ) {
      checkTotalValidation(
        bitubeState.totalValidation[bitubeState.currentOligoIndex].listErrors
      )
    } else {
      setSequenceValidation([])
      setNameValidationErrors([])
      setOverhangValidation([])
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.totalValidation])

  React.useEffect(() => {
    if (
      !nameValidationErrors.length &&
      !sessionData[currentOligoIndex].listError.length
    ) {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
    }
  }, [nameValidationErrors])

  React.useEffect(() => {
    if (validateOnClick) {
      const isReviewErrorsResolved =
        sessionData[currentOligoIndex].listError.length === 1 &&
        sessionData[currentOligoIndex].listError[0].key ===
          BitubeProperties.ReviewError
      if (isReviewErrorsResolved) {
        biTubeDispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
        biTubeDispatch({
          type: 'VALIDATE_ON_CLICK',
          data: false,
        })
      }
    }
  }, [nameValidationErrors, sequenceValidation])

  React.useEffect(() => {
    if (bitubeState.errorOnPageRefresh) {
      checkTotalValidation(sessionData[currentOligoIndex].listError)
    }
  }, [bitubeState.errorOnPageRefresh])

  React.useEffect(() => {
    if (bitubeState.clearSessionData) {
      setSenseName('')
      setSenseSequence('')
      const sessionArray = [
        {
          isOverridden: false,
          name: '',
          sequence: '',
          fiveMod: '',
          purification: '',
          baseCount: 0,
          format: '',
          concentration: '',
          tubes: '1',
          price: '',
          scale: '',
          orderItemId: '',
          id: '1',
          comments: '',
          additionalComments: '',
          oligoId: 0,
          countryCode: '',
          autoValidation: 'false',
          productType: '',
          customerOverhang: '',
          antisenceName: '',
          antisenceSequence: '',
          autoGenerateOligo: false,
          customerAntisenseOverHang: '',
          antisenceBaseCount: 0,
          amount: '',
          senseNameCheck: false,
          listError: [{ key: '', value: '' }],
          currencySymbol: '',
          currency: '',
          antisenceThreeMod: '',
          antisenceFiveMod: '',
          threeMod: '',
        },
      ]
      bitubeState.sessionData = sessionArray
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: sessionArray,
      })
      biTubeDispatch({
        type: 'CLEAR_SESSION_DATA',
        data: false,
      })
    }
    // TODO: need a test before we refactor this
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.clearSessionData])

  React.useEffect(() => {
    if (
      bitubeState.isPageLoad === 1 &&
      sessionData !== null &&
      sessionData.length !== 0 &&
      sessionData[bitubeState.currentOligoIndex] !== null
    ) {
      setSenseName(sessionData[currentOligoIndex].name)
      if (
        Object.keys(sessionData[bitubeState.currentOligoIndex]).length !== 0
      ) {
        biTubeDispatch({
          type: 'UPDATE_PAGE_LOAD',
          data: 2,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bitubeState.isPageLoad])

  React.useEffect(
    () => {
      // Make sure we have a value (user has entered something in input)
      setIsSequencekeyUp(false)
      if (debouncedSequenceData) {
        if (isSequence) {
          callSeqValidationAPI()
        }
        setIsSequence(false)
      }
      if (senseSequence === '' && isSeqEmpty) {
        setSequenceValidation([
          intl.formatMessage(messages.CONF_REQUIRED_FIELD),
        ])
        let hasSameErr = false
        sessionData[currentOligoIndex].listError.forEach((err) => {
          //if the same error is there in sessiondata, do not push the error
          if (
            err.key === sequenceKey &&
            err.value === intl.formatMessage(messages.CONF_REQUIRED_FIELD)
          ) {
            hasSameErr = true
          }
        })
        if (!hasSameErr)
          sessionData[currentOligoIndex].listError.push({
            key: sequenceKey,
            value: intl.formatMessage(messages.CONF_REQUIRED_FIELD),
          })
        callSeqValidationAPI()
      } else {
        if (sessionData[currentOligoIndex].sequence !== '') {
          const seqError: ListError[] = []
          sessionData[currentOligoIndex].listError.forEach((err) => {
            if (
              err.key === sequenceKey &&
              err.value === intl.formatMessage(messages.CONF_REQUIRED_FIELD)
            ) {
              seqError.push(err)
            }
          })
          const array = sessionData[currentOligoIndex].listError
          seqError.forEach((e) => {
            const index = array.indexOf(e)
            if (index !== -1) {
              array.splice(index, 1)
            }
          })
        }
      }
    },
    // This is the useEffect input array
    // Our useEffect function will only execute if this value changes ...
    // ... and thanks to our hook it will only change if the original ...
    // value (searchTerm) hasn't changed for more than 500ms.
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSequenceData]
  )
  const duplexComponent = () => {
    if (productDetails.productType === 'duplex') {
      return (
        <div>
          <Grid container direction="row" className={classes.mt20}>
            <Grid item xs={2} className={classes.overhangLabel}>
              <FormLabel className={classes.label}>
                <FormattedMessage {...messages.CONF_5_MOD_standard} />
              </FormLabel>
            </Grid>
            <Grid item xs={6}>
              <FormLabel className={classes.label}>
                <FormattedMessage {...messages.CONF_SENSE_SEQUENCE} />
                &nbsp;
                <FormattedMessage {...messages.CONF_SEQUENCE_TYPE} />
              </FormLabel>
            </Grid>
            <Grid item xs={2} className={classes.overhangLabel}>
              <FormLabel className={classes.label}>
                <FormattedMessage {...messages.CONF_OVERHANG_LABEL} />
              </FormLabel>
            </Grid>
            <Grid item xs={2} className={classes.overhangLabel}>
              <FormLabel className={classes.label}>
                <FormattedMessage {...messages.CONF_3_MOD_standard} />
              </FormLabel>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item sm={2}>
              <Field
                name="fiveMod"
                component={LiquidSelectAdapter}
                label=""
                value={fiveMod}
                options={[
                  ...getFiveModValue(
                    DefaultValue.FiveModiFication,
                    DefaultValue.Category,
                    specifications,
                    bitubeState.errorResponseJson
                  ),
                ]}
                onChange={handleDropDownSelect}
                filled
              />
            </Grid>

            <Grid item xs={6}>
              <Field
                name="sequence"
                component={LiquidInputAdapter}
                filled
                autoComplete="off"
                spellcheck={'false'}
                value={senseSequence}
                onClick={handleClick}
                onChange={(e) => {
                  setIsSeqEmpty(true)
                  setSenseSequence(e.target.value)
                  countText(convertToASCII(e.target.value))
                  setIsSequence(true)
                  setIsSequencekeyUp(true)
                }}
              />
              <div
                className={clsx(
                  classes.baseContent,
                  GlobalCSS.globalHelpTextColor,
                  GlobalCSS.sequenceBaseCountText
                )}
              >
                <span>{instructions}</span>
                <span>
                  <FormattedMessage {...messages.CONF_BASE_COUNT_standard} />
                  {isSequencekeyUp
                    ? baseCount
                    : sequenceValidation.length === 0
                      ? baseCount
                      : ' --'}
                </span>
              </div>
              <div
                className={clsx(
                  classes.baseContent,
                  GlobalCSS.globalHelpTextColor
                )}
              >
                <FormattedMessage {...messages.CONF_FASTDUPLEX_SEQ_INFO} />
              </div>
              <div>
                <ValidationErrors errors={sequenceValidation} />
              </div>
            </Grid>

            <Grid />
            <Grid item sm={2}>
              <Field
                name="customerOverhang"
                component={LiquidSelectAdapter}
                label=""
                value={overhang}
                options={[
                  selectOverhang,
                  ...getOverhangValue(
                    DefaultValue.OverHang,
                    DefaultValue.Category,
                    specifications,
                    bitubeState.errorResponseJson
                  ),
                ]}
                onChange={handleDropDownSelect}
                filled
              />
              <div>
                <ValidationErrors errors={overhangValidation} />
              </div>
            </Grid>
            <Grid item sm={2}>
              <Field
                name="threeMod"
                component={LiquidSelectAdapter}
                label=""
                value={threeMod}
                options={[
                  ...getThreeModValue(
                    DefaultValue.ThreeModification,
                    DefaultValue.Category,
                    specifications,
                    bitubeState.errorResponseJson
                  ),
                ]}
                onChange={handleDropDownSelect}
                filled
              />
            </Grid>
            <Grid item sm={5}>
              <div className={classes.base}>
                <Field
                  name="base"
                  component={LiquidSelectAdapter}
                  value={DefaultValue.AddBases}
                  options={[
                    {
                      label: DefaultValue.AddBases,
                      value: DefaultValue.AddBases,
                    },
                    ...getBaseValue(DefaultValue.Base, specifications),
                  ]}
                  onChange={handleDropDownSelectBase}
                  filled
                ></Field>
              </div>
            </Grid>

            <Grid />
          </Grid>
        </div>
      )
    } else {
      //for fastfuplex
      return (
        <div>
          <Grid container direction="row" className={classes.mt20}>
            <Grid item xs={8}>
              <FormLabel className={classes.label}>
                <FormattedMessage {...messages.CONF_SENSE_SEQUENCE} />
                &nbsp;
                <FormattedMessage {...messages.CONF_SEQUENCE_TYPE} />
              </FormLabel>
            </Grid>
            <Grid item xs={3} className={classes.overhangLabel}>
              <FormLabel className={classes.label}>
                <FormattedMessage {...messages.CONF_OVERHANG_LABEL} />
              </FormLabel>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item xs={8}>
              <Field
                name="sequence"
                component={LiquidInputAdapter}
                filled
                autoComplete="off"
                spellcheck={'false'}
                value={senseSequence}
                onChange={(e) => {
                  setIsSeqEmpty(true)
                  setSenseSequence(e.target.value)
                  countText(convertToASCII(e.target.value))
                  setIsSequence(true)
                  setIsSequencekeyUp(true)
                }}
              />
              <div
                className={clsx(
                  classes.baseContent,
                  GlobalCSS.globalHelpTextColor,
                  GlobalCSS.sequenceBaseCountText
                )}
              >
                <span>{instructions}</span>
                <span>
                  <FormattedMessage {...messages.CONF_BASE_COUNT_standard} />
                  {isSequencekeyUp
                    ? baseCount
                    : sequenceValidation.length === 0
                      ? baseCount
                      : ' --'}
                </span>
              </div>
              <div
                className={clsx(
                  classes.baseContent,
                  GlobalCSS.globalHelpTextColor
                )}
              >
                <FormattedMessage {...messages.CONF_FASTDUPLEX_SEQ_INFO} />
              </div>
              <div>
                <ValidationErrors errors={sequenceValidation} />
              </div>
            </Grid>
            <Grid item sm={2}>
              <Field
                name="customerOverhang"
                component={LiquidSelectAdapter}
                label=""
                value={overhang}
                options={[
                  selectOverhang,
                  ...getOverhangValue(
                    DefaultValue.OverHang,
                    DefaultValue.Category,
                    specifications,
                    bitubeState.errorResponseJson
                  ),
                ]}
                onChange={handleDropDownSelect}
                filled
              />
              <div>
                <ValidationErrors errors={overhangValidation} />
              </div>
            </Grid>
            <Grid />
          </Grid>
        </div>
      )
    }
  }

  return (
    <div className={classes.contentWrapper}>
      <h2 className={classes.subHead}>
        <FormattedMessage {...messages.CONF_SEQUENCE_ENTRY} />
      </h2>
      <h4>
        <FormattedMessage {...messages.CONF_DUPLEX_SENSE_STRAD} />
        <Tooltip
          title={<FormattedMessage {...messages.CONF_DNA_OLIGO_NAME_TOOLTIP} />}
          classes={{ tooltip: classes.InfoPopup, arrow: classes.arrow }}
          arrow
          placement="bottom-end"
        >
          <InfoIcon
            aria-label="info"
            className={classes.InfoIcon}
            color="primary"
          ></InfoIcon>
        </Tooltip>
      </h4>
      <Box>
        <Formik
          initialValues={{}}
          //validateOnChange={false}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <Grid container spacing={10}>
                <Grid item xs={8} className={classes.alignTop2}>
                  <span className={classes.label}>
                    <FormattedMessage {...messages.CONF_SENSE_NAME} />
                  </span>
                  <Field
                    name="name"
                    component={LiquidInputAdapter}
                    className={classes.sequenceInput}
                    rootClass={classes.sequenceLabel}
                    onBlur={handleOnBlur}
                    spellcheck={'false'}
                    filled
                    value={senseName}
                    onChange={(e) => {
                      handleName(validateText(convertToASCII(e.target.value)))
                    }}
                  />
                  <div
                    className={clsx(
                      classes.baseContent,
                      GlobalCSS.globalHelpTextColor
                    )}
                  >
                    <FormattedMessage
                      {...messages.CONF_ASCII_CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE}
                    />
                  </div>
                  <div className={classes.validateError}>
                    <ValidationErrors errors={nameValidationErrors} />
                  </div>
                </Grid>
              </Grid>
              {senseName !== null && senseName !== undefined ? (
                senseName.trim().length > 18 ? (
                  <div className={classes.warningBox}>
                    <OligoNameWarning
                      warning={intl.formatMessage(
                        messages.CONF_OLIGO_NAME_WARNING
                      )}
                    />
                  </div>
                ) : (
                  ''
                )
              ) : (
                ''
              )}
              <div>{duplexComponent()}</div>
              <Antisense
                modificationData={specifications}
                productDetails={productDetails}
              />
            </>
          )}
        </Formik>
      </Box>
    </div>
  )
}

export default FastSequenceInfo
